/**
 * Permission identifiers for the administrative affairs module — Issue #365.
 *
 * Mirrors apps/api/src/auth/services/module-catalog.ts so frontend gating
 * cannot diverge from backend RBAC.
 */
import { hasAnyPermission, hasPermission } from './crmPermissions';

export { hasAnyPermission, hasPermission };

export const ADMIN_AFFAIRS_PERMISSIONS = {
  READ: 'admin_affairs:read',
  WRITE: 'admin_affairs:write',
  APPROVE: 'admin_affairs:approve',
  MANAGE: 'admin_affairs:manage',
  ANNOUNCEMENT_READ: 'admin_announcements:read',
  ANNOUNCEMENT_WRITE: 'admin_announcements:write',
  ANNOUNCEMENT_MANAGE: 'admin_announcements:manage',
} as const;

export function canSeeAdminAffairsMenu(
  permissions: readonly string[],
): boolean {
  return hasAnyPermission(permissions, [
    ADMIN_AFFAIRS_PERMISSIONS.READ,
    ADMIN_AFFAIRS_PERMISSIONS.WRITE,
    ADMIN_AFFAIRS_PERMISSIONS.ANNOUNCEMENT_READ,
  ]);
}
